var exports = {
  "V": "xcc377c0b--b87299--salesLeaderIcon",
};

module.exports = exports;
